<template>
    <el-link target="_blank" :href="url">点击下载</el-link>
</template>

<script>
export default {
    props:{
        url: String
    }
}
</script>

<style>

</style>